import { useCallback, useState } from "react";

import useMutate from "../../../../hooks/useMutate";

export function useBoardMutationDialog({
  apiFn,
  invalidateKeys = ["boards"],
  onSuccess,
  onError,
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const closeDialog = useCallback(() => {
    setIsDialogOpen(false);
  }, []);

  const handleSuccess = useCallback(
    (...args) => {
      setIsSubmitting(false);
      closeDialog();
      onSuccess?.(...args);
    },
    [closeDialog, onSuccess]
  );

  const handleError = useCallback(
    (...args) => {
      setIsSubmitting(false);
      closeDialog();
      onError?.(...args);
    },
    [closeDialog, onError]
  );

  const { mutate } = useMutate(
    apiFn,
    invalidateKeys,
    () => {},
    handleSuccess,
    handleError
  );

  const openDialog = useCallback(() => {
    setIsDialogOpen(true);
  }, []);

  const submit = useCallback(
    (payload) => {
      setIsSubmitting(true);
      mutate(payload);
    },
    [mutate]
  );

  return {
    isDialogOpen,
    isSubmitting,
    openDialog,
    closeDialog,
    submit,
  };
}
